/** Accessibilité clavier des éléments cliquables non natifs (lignes, cartes, fonds de modale). */

const ACTIVATION_KEYS = new Set(["Enter", " ", "Spacebar"]);

/** Carte/ligne cliquable : activable au clavier (Entrée / Espace) et focusable. */
export function clickable(onClick, { label } = {}) {
  return {
    role: "button",
    tabIndex: 0,
    onClick,
    onKeyDown: (e) => {
      if (!ACTIVATION_KEYS.has(e.key)) return;
      e.preventDefault();
      onClick?.(e);
    },
    ...(label ? { "aria-label": label } : {}),
  };
}

/** Fond de modale : clic ou touche Échap ferment la fenêtre.
 *  L'écoute d'Échap est posée sur le document (le fond n'a jamais le focus). */
export function backdrop(onClose, { selfOnly = false } = {}) {
  const onEscape = (e) => {
    if (e.key === "Escape") onClose?.(e);
  };
  return {
    role: "button",
    tabIndex: -1,
    "aria-label": "Fermer la fenêtre",
    onClick: (e) => {
      if (selfOnly && e.target !== e.currentTarget) return;
      onClose?.(e);
    },
    onKeyDown: onEscape,
    ref: (el) => {
      if (el) document.addEventListener("keydown", onEscape);
      else document.removeEventListener("keydown", onEscape);
    },
  };
}

/** Conteneur interne d'une modale : empêche la fermeture au clic à l'intérieur. */
export const stopPropagation = {
  onClick: (e) => e.stopPropagation(),
};

/** Idem, pour un conteneur `div` purement décoratif (rôle de présentation). */
export const presentation = {
  role: "presentation",
  onClick: (e) => e.stopPropagation(),
};
